let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kXjNG")).then(() => parcelRequire('jN0Pk'));